import { render } from "./ProviderTable.vue?vue&type=template&id=6114e8fb&scoped=true&ts=true"
import script from "./ProviderTable.vue?vue&type=script&lang=ts"
export * from "./ProviderTable.vue?vue&type=script&lang=ts"

import "./ProviderTable.vue?vue&type=style&index=0&id=6114e8fb&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6114e8fb"]])

export default __exports__